/* global TD, FS */

import $ from "jquery";
import "./td-ctrl";

var data_rowedit_attr = "data-td-rowedit-disable";
var data_rowedit_newrow = "data-td-rowedit-newrow";

// disable interactive controls
function beforeRequest(tr) {
	var form = tr.closest("form");
	var cd = $(".ui-button,input[type=\"checkbox\"]", form);
	cd.each(function(i, e) {
		e = $(e);
		if(!e.prop("disabled") && !e.hasClass("ui-disabled"))
			e.attr(data_rowedit_attr, "").prop("disabled", true).addClass("ui-disabled", "");
	});
}

function completeRequest(tr) {
	var form = tr.closest("form");
	$(".ui-button[" + data_rowedit_attr + "],input[type=\"checkbox\"][" + data_rowedit_attr + "]", form).prop("disabled", false).removeClass("ui-disabled");
}

function setRowHtml(tr, data) {
	var x, trp = tr.parent();
	if(data.html) {
		x = $(data.html);
		// js always sends fs-odd
		if(tr[0].sectionRowIndex % 2)
			x.removeClass("fs-odd");
		tr.replaceWith(x);
		// attach toolactions
		$("button.fs-toolaction", x).toolaction({ from: "@data-menu", appendMenuTo: "parent" });
	}
	else {
		tr.remove();
	}
	completeRequest(trp);
	return x;
}

function setRowData(tr, data, ts) {
	var td = $("td", tr).first();
	for(var x in data.record) {
		td = td.next();
		if(!td.length) break;
		var r = data.record[x];
		tr.prepend($("<input/>", { name: "o_" + x, type: "hidden", value: r.value }));
		var h = r.html;
		td.empty().append($("<div/>", { id: x + "_value", "class": r.type == 2 ? "ui-required" : "" }).html(h));
	}
	if(ts)
		tr.prepend($("<input/>", { name: "ts", type: "hidden", value: ts }));
}

function setErrors(tr, c) {
	if(c != null && c.length) {
		var td = $("<td>", { colspan: 255 });
		for(var i = 0; i < c.length; i++) {
			var div = $("<div/>", { "class": "ui-alert ui-icon-error" }).text(c[i]);
			td.append(div);
		}
		tr.after($("<tr>", { "class": "ui-grid-row-error" + (tr.hasClass("fs-odd") ? " fs-odd" : "") }).append(td));
	}
}

function removeErrors(tr) {
	// remove any previous errors
	$("td div.ui-alert.ui-icon-error", tr).remove();
	tr.next("tr.ui-grid-row-error").remove();
}

function onAjaxError(tr, textStatus, errorThrown) {
	setErrors(tr, [textStatus + " " + errorThrown]); // create error row, remove it after 5 seconds
	setTimeout(function() { tr.next("tr.ui-grid-row-error").remove(); }, 5000);
}

function makeUrl(url, options) {
	var n = url.indexOf("?"), o = {};
	if(n >= 0) {
		$.qstring(url.substring(n)).each(function(k, v) { o[k] = v; });
		url = url.substring(0, n);
	}
	return url + "?" + $.param($.extend(o, options));
}

function enableSaveCancel(tr, value) {
	tr.find(">td:first>nobr>button").prop("disabled", !value);
}

function updateLayout() {
	$(window).trigger("resize");
}

function saveRow(tr, baseUrl, callback) {
	removeErrors(tr); // remove previous errors
	baseUrl = makeUrl(baseUrl, { cmd: "rowsave" });
	var d = $("input,button,textarea,select", tr).serialize();
	enableSaveCancel(tr, false);

	var trTop = tr.offset().top - $(window).scrollTop();

	$.ajax(baseUrl, {
		dataType: "json",
		type: "POST",
		data: d,
		success: function(data) {
			var tfoots = tr.closest("table").find(">tbody.fs-groupfoot");
			enableSaveCancel(tr, true);
			var ctx = saveComplete(tr, data);
			if(ctx !== false) {
				tfoots.addClass("ui-invalid");
				if(ctx != null) window.scrollBy(0, ctx.offset().top - $(window).scrollTop() - trTop);
				if(callback) callback(true);
			}
		},
		error: function(xhr, textStatus, errorThrown) {
			enableSaveCancel(tr, true);
			setErrors(tr, [textStatus + " " + errorThrown]);
		},
		complete: updateLayout
	});
}

function saveComplete(tr, data) {
	var err;
	if(data.html != null) {
		return setRowHtml(tr, data);
	}
	else if((err = data.controldata.invalid)) // any errors?
	{
		var c = err.common || [];
		for(var f in err) {
			if(f != "common") {
				var fe = $("#" + f + "_value");
				if(fe.length) // if cell is found
				{
					var errDiv = fe.find(">div.ui-alert.ui-icon-error");
					if(!errDiv.length)
						errDiv = $("<div/>", { "class": "ui-alert ui-icon-error" }).appendTo(fe);
					errDiv.text(err[f]);
				}
				else // add to common errors
					c.push(err[f]);
			}
		}
		setErrors(tr, c);
		return false;
	}
}

function cancelRow(tr, baseUrl, callback) {
	removeErrors(tr);
	if(!tr.data(data_rowedit_newrow)) // new row? do not query
	{
		var trTop = tr.offset().top - $(window).scrollTop();

		baseUrl = makeUrl(baseUrl, { cmd: "rowcancel" });
		enableSaveCancel(tr, false);
		$.ajax(baseUrl, {
			cache: false,
			dataType: "json",
			success: function(data) {
				enableSaveCancel(tr, true);
				var ctx = setRowHtml(tr, data);
				if(ctx != null) window.scrollBy(0, ctx.offset().top - $(window).scrollTop() - trTop);
				if(callback) callback(false);
			},
			error: function(xhr, s, e) {
				enableSaveCancel(tr, true);
				onAjaxError(tr, s, e);
			},
			complete: updateLayout
		});
	}
	else {
		setRowHtml(tr, { html: "" });
		if(callback) callback(false);
		updateLayout();
	}
}

function startEdit(tr, baseUrl, callback) {
	// disable form controls
	beforeRequest(tr);

	// note row's vertical position
	var trTop = tr.offset().top - $(window).scrollTop();

	// perform GET for the editors HTML code
	$.ajax(baseUrl, {
		cache: false,
		dataType: "json",
		success: function(data) {
            tr.css({ "background-color": "", "color": "" })
			.find(">td:first>nobr")
			.empty()
			.append(
				$("<button>", { type: "submit", "class": "ui-button" }).text(TD.Res["action.save"]).on("click", function() {
					saveRow(tr, baseUrl, callback);
					return false;
				}),
				$("<button>", { type: "reset", "class": "ui-button" }).text(TD.Res["action.cancel"]).on("click", function() {
					cancelRow(tr, baseUrl, callback);
					return false;
				}));
			setRowData(tr, data, data.controldata.ts);
			FS.Form.init(tr);
			TD.Ctrl.initDeps(tr, data.controldata);
			TD.Ctrl.initForm(tr, function(ctx) {
				window.scrollBy(0, tr.offset().top - $(window).scrollTop() - trTop);
				TD.Ctrl.setFocus(ctx);
			});
		},
		error: function(xhr, s, e) {
			// enable back form controls
			if(callback) callback(false);
			completeRequest(tr);
			// display error message banner
			onAjaxError(tr, s, e);
		},
		complete: updateLayout
	});
}

function startEditRow(newTr, tr, callback) {
	return function(success) {
		if(success) {
			if(tr) tr.remove();
		}
		else {
			newTr.remove();
			if(tr) tr.show();
		}
		if(callback)
			callback(success);
	};
}

function startNewImpl(table, url, callback) {
	var ncols = $("thead>tr:first-child>th", table).length;
	table = table[0];
	var i, newTr = $("<tr/>").data(data_rowedit_newrow, true);
	for(i = 0; i < ncols; i++) {
		var td = $("<td/>");
		if(i === 0)
			td.addClass("fs-fixedcol").append($("<nobr/>"));
		newTr.append(td);
	}
	for(i = table.tBodies.length - 1; i >= 0; i--) {
		var tbody = $(table.tBodies[i]);
		if(!tbody.is(".fs-grouphead,.fs-groupfoot,.fs-tfoot")) {
			if(tbody.is(".fs-nodata")) {
				var newTbody = $("<tbody>").append(newTr.addClass("fs-odd")).insertAfter(tbody.hide());
				startEdit(newTr, url, startEditRow(newTbody, tbody, callback));
			}
			else {
				var tr = tbody.find(">tr:last-child");
				if(!tr.hasClass("fs-odd"))
					newTr.addClass("fs-odd");
				newTr.insertAfter(tr);
				startEdit(newTr, url, startEditRow(newTr, null, callback));
			}
			return false;
		}
	}
}

function makeStartAgainCallback(table, url) {
	var callback = function(success) {
		if (success) { startNewImpl(table, url, callback); }
	};
	return callback;
}


function start(b, url, callback) {
	startEdit($(b).closest("tr"), url, callback);
}

function startNew(b, url) {
	var table = $(b).closest("form").find("table.fs-grid:first");
	if(table.length == 1) {
		return startNewImpl(table, url, makeStartAgainCallback(table, url));
	}
}

function autoEdit(t) {
	t = $("tbody:first", t);
	var rs = "tr:first td:first", b = rs + " button:first";
	var bx = $(b, t);
	var u = JSON.parse(/^TD\.RowEdit\.start\(this,\s*(".+")\)$/.exec(bx.attr("onclick"))[1]);
	bx.removeAttr("onclick");
	t.on("change", function() {
		$(b, this)[0].click();
	}).on("click", b, function() {
		start($(rs, t), u, function(s) {
			if(s) { // success, reload
				location.reload();
			}
			else { // cancelled
				$(b, t).removeAttr("onclick");
			}
		});
	});
	bx[0].click();
}

export { start, startNew, autoEdit };

